import STATE from '../constants/state';

const selectors = {
  item: '.js-animate',
};

const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const item = entry.target;

        item.classList.add(STATE.inView);

        observer.unobserve(item);
      }
    });
  },
  {
    rootMargin: '-20%',
  },
);

const handleAnimations = () => {
  if (!window.IntersectionObserver) return;

  const items = document.querySelectorAll(selectors.item);

  if (!items.length) return;

  items.forEach((img) => observer.observe(img));
};

export default handleAnimations;
